import { useState } from 'react';
import EditorialInbox from './EditorialInbox';
import StoryManager from './StoryManager';

type View = 'inbox' | 'library';

const VIEWS: { id: View; label: string; icon: string }[] = [
  { id: 'inbox', label: 'Editorial inbox', icon: 'ri-inbox-archive-line' },
  { id: 'library', label: 'Library & create', icon: 'ri-book-2-line' },
];

/**
 * Editorial workspace — the unified home for incoming stories (the inbox) and
 * the existing story library / creation tools (including the AI Story Studio).
 * Everything is local-state only; nothing is persisted or published.
 */
export default function EditorialWorkspace() {
  const [view, setView] = useState<View>('inbox');

  return (
    <div className="space-y-6">
      <div className="inline-flex flex-wrap gap-1 bg-background-100 border border-background-200 rounded-full p-1">
        {VIEWS.map((v) => (
          <button
            key={v.id}
            type="button"
            onClick={() => setView(v.id)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-label font-bold uppercase tracking-wider text-[11px] whitespace-nowrap cursor-pointer transition-colors ${view === v.id ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-950'}`}
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className={v.icon}></i></span>
            {v.label}
          </button>
        ))}
      </div>

      {view === 'inbox' ? <EditorialInbox /> : <StoryManager />}
    </div>
  );
}